import React, { useEffect, useState } from "react";
import "../style/admin.css";
import Sidebar from "./partial/Sidebar";
import Header from "./partial/Header";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { useAllThemeQuery, useDeleteThemeMutation } from "../../redux/API/ThemeApi";
import DeleteModal from "./partial/DeleteModal";
import toast, { Toaster } from "react-hot-toast";
import ChangePassword from "./partial/ChangePassword";
import { ImgUrl, themeImgUrl } from "../Constant";

const AdminTheme = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeletId] = useState("");
  const [rows, setRows] = useState([]);
  const { data, refetch } = useAllThemeQuery();
  // const [deleteTheme] = useDeleteThemeMutation();
  
const [deleteTheme] = useDeleteThemeMutation()
  const handleShow = (id)  => {
  
    setDeletId(id)
    setShowModal(true)
  }


  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  


  const handleToggle = () => {
    setNewClass(newClass === "" ? "main-active" : "");
    setNewSidebarClass(newSidebarClass === "" ? "closed" : "");
  };

  const handleDelete = async () => {
    try {
      await deleteTheme(deleteId).unwrap();
      setShowModal(false);
      refetch();
      toast.success("Theme Deleted Successfully");
    } catch (error) {
      setShowModal(false);
      toast.error("Something went wrong, Please try again later");
    }
  };

  useEffect(() => {
    if (data) {
      const updatedRows = data?.themes?.map((i) => ({
        id: i._id,
        image: i.image || "",
        name: i.name || "N/A",
        overview: stripHtml(i.overview) || "N/A",
        itinerary: stripHtml(i.itinerary) || "N/A",
        otherInfo: stripHtml(i.otherInfo) || "N/A",
        slug: i.slug || "N/A"
      }));
      setRows(updatedRows);
    }
    
    refetch();
  }, [data, refetch]);

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} setShowPass={setShowPass} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Themes
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/addtheme" className="btn btn-primary">
              Add Theme <FaPlus />
            </Link>
          </div>
          <div className="card p-4">
            <div className="table-wrapper w-100 overflow-x-auto">
              <table className="table table-bordered admin_table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Image</th>
                    <th scope="col">Theme Name</th>
                    <th scope="col">Overview</th>
                    <th scope="col">Itinerary</th>
                    <th scope="col">Other Info</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <img
                          src={`${ImgUrl}${themeImgUrl}${row.image}`}
                          width={100}
                        />
                      </td>
                      <td className="text-capitalize">{row.name}</td>
                      <td className="text-capitalize">{row.overview}</td>
                      <td className="text-capitalize">{row.itinerary}</td>
                      <td className="text-capitalize">{row.otherInfo}</td>
                      {/* <td className="text-capitalize">{row.description}</td> */}
                      <td>
                        <Link
                          to={`/admin/edit-theme/${row.slug}`}
                          className="fs-6 text-black"
                        >
                          <FaEdit />
                        </Link>
                        <Link
                          onClick={() => handleShow(row._id)}
                          className="text-danger ms-3 fs-6"
                        >
                          <FaTrash />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <DeleteModal
          title={"Theme"}
          handleDelete={handleDelete}
          setShowModal={setShowModal}
        />
      )}
      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default AdminTheme;
